import React, { useContext } from "react";
import { Notyf } from "notyf";

const NotyfContext = React.createContext(
  new Notyf({
    duration: 3000,
    position: {
      x: "right",
      y: "bottom",
    },
    dismissible: true,
    ripple: true,
    types: [
      {
        type: "default",
        backgroundColor: "#3B7DDD",
        icon: {
          className: "notyf__icon--success",
          tagName: "i",
        },
      },
      {
        type: "success",
        backgroundColor: "#28a745",
        icon: {
          className: "notyf__icon--success",
          tagName: "i",
        },
      },
      {
        type: "warning",
        backgroundColor: "#ffc107",
        icon: {
          className: "notyf__icon--error",
          tagName: "i",
        },
      },
      {
        type: "danger",
        backgroundColor: "#dc3545",
        icon: {
          className: "notyf__icon--error",
          tagName: "i",
        },
      },
    ],
  })
);

export function useNotyf() {
  return useContext(NotyfContext);
}

export default NotyfContext;
